<template>
    <v-container fluid>
        <div v-if="!loading">
            <v-row>
                <v-col>
                    <h4 class="text-h4">{{$t('edit_driver')}}: <span class="font-weight-bold">{{form ? form.name : null}}</span></h4>
                    <p class="text-subtitle">{{$t('Driver_Edit_Form')}}</p>
                    <v-divider></v-divider>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" md="6">
                    <DriverForm
                        :name.sync="form.name"
                        :phone.sync="form.phone"
                        />
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" md="3">
                    <v-btn
                        block
                        color="primary"
                        @click="handleSave"
                        :loading="loading"
                    >
                        <v-icon left>
                            mdi-content-save
                        </v-icon>
                        {{$t('save')}}
                    </v-btn>
                </v-col>
                <v-col cols="12" md="3">
                    <v-btn
                        @click="handleCancel"
                        block
                        depressed
                    >
                        {{$t('cancel')}}
                    </v-btn>
                </v-col>
            </v-row>
        </div>
        <div v-else>
            <v-row>
                <v-col>
                    <v-skeleton-loader type="heading" class="my-4"/>
                    <v-skeleton-loader type="text" class="my-2"/>
                    <v-divider/>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="6">
                    <v-skeleton-loader type="text" class="my-2"/>
                    <v-skeleton-loader type="text"/>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" md="3" >
                    <v-skeleton-loader type="button" />
                </v-col>
                <v-col cols="12" md="3">
                    <v-skeleton-loader type="button" />
                </v-col>
            </v-row>
        </div>
        <PAlert v-model="alert.model" v-bind="alert"/>

    </v-container>
</template>

<script>
import service from './../../services/fleet/driver'
import { isRequired } from './../../utils/validations';
import PAlert from './../../components/common/PAlert.vue';
import DriverForm from './../../components/fleet/DriverForm.vue';
export default {
    name: "DriverEditView",
    components: {
        PAlert,
        DriverForm
    },
    data() {
        return {
            alert: {
                title: this.$t("alert_title"),
                content: "",
                callback: null,
                model: false
            },
            loading: false,
            id: null,
            form: {
                name: "",
                phone: ""
            }
        }
    },
    methods: {
        isRequired,
        handleSave() {
            this.alert = {...this.alert, model: true, content: this.$t("are_you_sure_you_want_to_save"), callback: this.save}
        },
        save() {
            this.loading = true;
            service.update(this.id, this.form).then(response => {
                this.$router.replace({ name: "DriverDisplay", params: { driverID: response.data.id } })
            }).finally(() => {
                this.loading = false;
            })
        },
        fetchDriver() {
            this.loading = true;
            service.get(this.id).then(response => {
                let data = response.data;
                this.form = {...data}; 
            }).finally(() => {
                this.loading = false;
            })
        },
        handleCancel() {
            this.alert = {...this.alert, model: true, content: this.$t("are_you_sure_cancel"), callback: this.cancel}
        },
        cancel() {
            this.$router.back();
        }
    },
    created() {
        this.id = this.$route.params.driverID;
        this.fetchDriver()
    }

}
</script>

<style>

</style>